import Image from 'next/image'
import { FC, useRef } from 'react'
import clsx from 'clsx'

import Overlay from 'containers/overlay/overlay'
import usePCWindow from 'hooks/usePCWindow'
import useToggle from 'hooks/useToggle'
import useOnClickOutside from 'hooks/useClickOutside'

import { ScreenSize } from 'constants/media-constanst'
import { imgData } from './data'

import styles from './course-certificat-preview.module.scss'

const CourseCertificatPreview: FC = () => {
  const isMob = usePCWindow(ScreenSize.mobile)
  const certFullSizeRef = useRef(null)
  const [isCertFullSizeOpened, toggleCertFullSizeOpened] = useToggle()

  useOnClickOutside(true, certFullSizeRef, toggleCertFullSizeOpened, [
    styles.imageDesktopWrapper,
    styles.imageWrapper,
  ])

  return (
    <>
      {isCertFullSizeOpened && (
        <Overlay>
          <div className={styles.certWrapper}>
            <div ref={certFullSizeRef}>
              <Image {...(isMob ? imgData.certificateFullMob : imgData.certificateFullDesk)} />
            </div>
          </div>
        </Overlay>
      )}
      <div className={styles.containerWrapper}>
        <div className={styles.container}>
          <div className={clsx(styles.wrapper)}>
            <p className={styles.title}>Выдаем удостоверение&nbsp;о повышении квалификации</p>
            <p className={styles.subtitle}>
              Мы обучаем по образовательной лицензии
              No&nbsp;Л035&nbsp;-&nbsp;01298&nbsp;-&nbsp;77/00496563
            </p>
            {isMob && (
              <div className={styles.imageWrapper} onClick={toggleCertFullSizeOpened}>
                <Image className={styles.image} {...imgData.certificate} />
              </div>
            )}
          </div>
          {!isMob && (
            <div className={styles.imageDesktopWrapper} onClick={toggleCertFullSizeOpened}>
              <Image className={styles.imageDesktop} {...imgData.certificateDesc} />
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default CourseCertificatPreview
